import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';  
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AdminComponent } from './admin.component';
import { LoadingComponent } from './loading.component';
import { LoaderService } from './services/loader.service';
import { MessageService } from './services/message.service';
import { HelpDeskService } from './services/helpdesk.service';
import { TrakiiLoginService } from './services/trakiilogin.service';
import { LensDispatchLoginService } from './services/lensdispatchlogin.service';
import { UserService } from './services/user.service';
import { AuthInterceptor } from './services/auth.interceptor';
import { DataExportService } from './services/dataexport.service';
import { GAService } from './services/ga.service';
import { RouterModule } from '@angular/router';
import { ChooseComponent } from './choose.component';
import { ShopLandingComponent } from './shoplanding.component';
import { DeniedComponent } from './denied.component';
import { NoShopComponent } from './noshop.component';
import { SharedModule } from './shared.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SuperAdminGuard } from './guards/superadmin.guard';
import { AuthGuard } from './guards/auth.guard';
import { AdminGuard } from './guards/admin.guard';
import { ChooseGuard } from './guards/choose.guard';
import { CitipostOnlyGuard } from './guards/citipostonly.guard';
import { TrakiiGuard } from './guards/trakii.guard';
import { LensDispatchGuard } from './guards/lensdispatch.guard';



@NgModule({
  declarations: [
    AppComponent,
    LoadingComponent,
    AdminComponent,
    ChooseComponent,
    ShopLandingComponent,
    DeniedComponent,
    NoShopComponent
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    RouterModule,
    AppRoutingModule,
    BrowserModule,
    SharedModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule  
  ],
  providers: [
    LoaderService,
    MessageService,
    HelpDeskService,
    TrakiiLoginService,
    LensDispatchLoginService,
    UserService,
    DataExportService,
    GAService,
    SuperAdminGuard,
    AuthGuard,
    AdminGuard,
    ChooseGuard,
    CitipostOnlyGuard,
    TrakiiGuard,
    LensDispatchGuard,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
